var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"request_page_content"},[_c('NewFormVue')],1),_c('div',{staticClass:"request_page_content"},[_c('CustomersVue')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }